import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [LIST_PLANS_TECHS, LIST_PLANS_TECHS_SUCCESS, LIST_PLANS_TECHS_FAILURE] =
  createRequestActionTypes('chance/LIST_PLANS_TECHS');

export const listPlanTechs = createAction(
  LIST_PLANS_TECHS,
  (searchData) => searchData,
);
const listPlanTechsSaga = createRequestSaga(
  LIST_PLANS_TECHS,
  techApi.getPlanTechs,
);

const UNLOAD_PLANS_TECHS = 'chance/UNLOAD_PLANS_TECHS';
export const unloadPlanTechs = createAction(UNLOAD_PLANS_TECHS);

export function* PlanTechsSaga() {
  yield takeLatest(LIST_PLANS_TECHS, listPlanTechsSaga);
}

const initialState = {
  techs: null,
  error: null,
};

const planTechs = handleActions(
  {
    [LIST_PLANS_TECHS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      techs: data.list.map((tech) => ({
        id: tech.workUuid,
        workUuid: tech.workUuid,
        prjUuid: tech.prjUuid,
        reqNo: tech.reqNo, //reqNo
        reqTitle: tech.reqTitle,
        reqTyp: tech.reqTyp,
        reqStrtDt: tech.reqStrtDt,
        reqEndDt: tech.reqEndDt,
        reqContext: tech.reqContext,
        reqUsr: tech.reqUsr,
        reqNm: tech.reqNm,
        plnTitle: tech.plnTitle,
        plnTyp: tech.plnTyp,
        plnStrtDt: tech.plnStrtDt,
        plnEndDt: tech.plnEndDt,
        plnContext: tech.plnContext,
        plnUsr: tech.plnUsr,
        plnNm: tech.plnNm,
        workStatus: tech.workStatus,
        workGrade: tech.workGrade,
        rsltUuid: tech.rsltUuid,
        useYn: tech.useYn,
        crtNm: tech.crtNm,
        crtDt: tech.crtDt,
        cngNm: tech.cngNm,
        cngDt: tech.cngDt,
      })),
      error: null,
    }),
    [LIST_PLANS_TECHS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_PLANS_TECHS]: () => initialState,
  },
  initialState,
);

export default planTechs;
